import React, { useCallback, useMemo, } from 'react';
import { ADD_ROW, JSON_KEY_TIME, TABLE_HEADER_TYPE, JSON_KEY_RESULTS_TYPE, 
   // TABLE_HEADER_ID, JSON_KEY_ID, 
   TABLE_HEADER_TIME, JSON_KEY_MESSAGE, TABLE_HEADER_MESSAGE, UNKNOWN, RESULTS_TYPE_REPLY_SUCCESS,
   RESULTS_NAME_REPLY_SUCCESS, RESULTS_TYPE_REPLY_ERROR, RESULTS_NAME_REPLY_ERROR
} 
from '../../common/common';
import VirtualizedTablesTemplate from './VirtualizedTablesTemplate';

const Results = () => {
   function ConvertResultsType(type) {
      switch (type) {
         case RESULTS_TYPE_REPLY_SUCCESS:
            return RESULTS_NAME_REPLY_SUCCESS;
         case RESULTS_TYPE_REPLY_ERROR:
            return RESULTS_NAME_REPLY_ERROR;
         default:
            return UNKNOWN;
      }
   }
   
   const handleSingleClick = useCallback((rowData) => {
      // console.log(`[ResultsTable] Row Clicked:`, rowData);
   }, []);

   const handleDoubleClick = useCallback((rowData) => {
      // console.log(`[ResultsTable] Row Double Clicked:`, rowData);
   }, []);

   const handleEvents = useCallback((details, setLocalTableData) => {
      // console.log('results details: ', details.data, 'r_type:', details.data.r_type, ', Message:', details.data.message, ', message:', JSON.stringify(details.data.message));

      const modifiedRow = {
         ...details.data,
         id: `${Date.now()}-${Math.random().toString(36).substring(2, 11)}`,
         message: JSON.stringify(details.data.message),
         r_type: ConvertResultsType(details.data.r_type),
      };

      switch (details.type) {
         case ADD_ROW: {
            setLocalTableData(prev => {
               const isDuplicate = prev.some(row => 
                  row.r_type === modifiedRow.r_type && row.message === modifiedRow.message
               );
   
               if (isDuplicate) {
                  console.log(`Duplicate result row ignored: ${modifiedRow.r_type} - ${modifiedRow.message}`);
                  return prev;
               }
   
               return [...prev, modifiedRow];
            });
            break;
         }

         default:
            console.log('Unknown event type:', details.type);
            break;
      }
   }, []);

   const columns = useMemo(() => [
      // { Header: TABLE_HEADER_ID, accessor: JSON_KEY_ID }, // don't show it but it is still there
      { Header: TABLE_HEADER_TIME, accessor: JSON_KEY_TIME },
      { Header: TABLE_HEADER_MESSAGE, accessor: JSON_KEY_MESSAGE },
      { Header: TABLE_HEADER_TYPE, accessor: JSON_KEY_RESULTS_TYPE },
   ], []);

   return (
      <VirtualizedTablesTemplate
         columns={columns}
         eventHandlers={handleEvents}
         tableName="ResultsTable"
         onRowClick={handleSingleClick}
         onRowDoubleClick={handleDoubleClick}
         highlightOnClick={true}
         enableSearch={true}
      />
   );
};

export default Results;
